/**
 * Snapshot de customer extraído do DOM / formulário.
 * Só campos preenchidos entram no evento.
 */
export type CustomerData = {
  email?: string;
  phone?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};

export function hasCustomerData(
  customer: CustomerData | null | undefined
): customer is CustomerData {
  if (!customer) return false;
  return Object.values(customer).some(
    value => typeof value === 'string' && value.trim().length > 0
  );
}

export function cloneCustomerData(customer: CustomerData): CustomerData {
  return { ...customer };
}
